var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conversations-list-wrap",class:{
    hide: !_vm.showConversationList,
    'list--full-width': _vm.isOnExpandedLayout,
  }},[_c('div',{staticClass:"chat-list__top"},[_c('h1',{staticClass:"page-title text-truncate",attrs:{"title":_vm.pageTitle}},[_vm._v("\n      "+_vm._s(_vm.pageTitle)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"boards-conversations"},[_c('call-list')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }